.list {
  list-style: none;
  margin: 0;
  padding: 4px 16px 16px;
  display: flex;
  flex-direction: column;
  gap: 18px;
}

.row {
  display: flex;
  gap: 12px;
  align-items: flex-start;
  animation: bb-fade-in var(--t-med) var(--ease);
}

.reply {
  gap: 10px;
}

.body {
  flex: 1;
  min-width: 0;
}

.head {
  display: flex;
  align-items: baseline;
  gap: 8px;
}

.name {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  font-size: var(--fs-sm);
  font-weight: 700;
  color: var(--text-2);
}

.time {
  font-size: var(--fs-xs);
  color: var(--text-3);
}

.text {
  margin-top: 3px;
  font-size: var(--fs-md);
  line-height: 1.4;
  word-wrap: break-word;
}

.actions {
  display: flex;
  gap: 16px;
  margin-top: 6px;
}

.actions button {
  font-size: var(--fs-xs);
  font-weight: 700;
  color: var(--text-3);
}

.actions button:hover {
  color: var(--text);
}

.replies {
  list-style: none;
  margin: 12px 0 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 14px;
}

.more {
  font-size: var(--fs-xs);
  font-weight: 700;
  color: var(--text-3);
}

.like {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 2px;
  min-width: 28px;
  padding-top: 4px;
  font-size: 11px;
  color: var(--text-3);
}

.liked {
  color: var(--accent);
}

.composer {
  display: flex;
  align-items: center;
  gap: 10px;
}

.inputWrap {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.inputWrap input {
  height: 42px;
  padding: 0 16px;
  border-radius: var(--r-full);
  background: var(--surface-2);
  border: 1px solid var(--border);
  outline: none;
}

.inputWrap input:focus {
  border-color: var(--accent);
}

.replyingTo {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  align-self: flex-start;
  font-size: var(--fs-xs);
  color: var(--text-2);
  font-weight: 600;
  padding-left: 8px;
}

.send {
  display: grid;
  place-items: center;
  width: 42px;
  height: 42px;
  border-radius: 50%;
  background: var(--accent);
  color: var(--accent-ink);
  transition: opacity var(--t-fast);
}

.send:disabled {
  opacity: 0.3;
}

.disabled {
  text-align: center;
  color: var(--text-3);
  font-size: var(--fs-sm);
  padding: 8px;
}
